import { css } from '@emotion/react'
import styled from '@emotion/styled'

import { Theme } from 'scripts/react-components/themes/Theme'

const sortersWrapperStyles = () => css`
  label: sorter-wrapper;

  position: relative;

  width: 100%;
`

const wrapperStyles = ({ theme }: Theme) => css`
  label: sort-select-stack;

  [target='sorter'] {
    ${theme.media.mega} {
      padding: ${theme.spacings.mega} 0;
    }

    & > div {
      padding: 0 ${theme.spacings.mega};
      overflow-y: hidden;
    }
  }
`

export const Wrapper = styled('div')(wrapperStyles)
export const WrapperSelect = styled('div')(sortersWrapperStyles)
